import api from "../../api";
import type {
  HomeApiResponse,
  HomeContentData,
} from "../../../@types/portalAluno";
import { mapHomeResponse } from "../../../utils/portalAluno/mappers/homeMapper";

export const portalHomeQueryKey = (idUsuario?: number) => [
  "portal-aluno",
  "home",
  idUsuario,
];

export const getHomeContents = async (): Promise<HomeContentData> => {
  const response = await api.get<HomeApiResponse>("mobile/home");

  return mapHomeResponse(response.data);
};
